import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './initialState';
import { getPeripheralProcessingConfigsAsync, putPeripheralProcessingConfigsAsync } from './asyncActions';

export const peripheralProcessingSlice = createSlice({
  name: 'peripheralProcessing',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPeripheralProcessingConfigsAsync.pending, (state) => {
        state.list.status = 'loading';
      })
      .addCase(getPeripheralProcessingConfigsAsync.fulfilled, (state, action) => {
        state.list.status = 'idle';
        state.list.data = action.payload?.items ?? [];
      })
      .addCase(getPeripheralProcessingConfigsAsync.rejected, (state) => {
        state.list.status = 'failed';
      })
      .addCase(putPeripheralProcessingConfigsAsync.pending, (state) => {
        state.saveStatus = 'loading';
      })
      .addCase(putPeripheralProcessingConfigsAsync.fulfilled, (state) => {
        state.saveStatus = 'idle';
      })
      .addCase(putPeripheralProcessingConfigsAsync.rejected, (state) => {
        state.saveStatus = 'failed';
      });
  },
});

export default peripheralProcessingSlice.reducer;
